<template>
  <!-- <div id="donut-chart"> -->
    <apexchart
      type="donut"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    chartOptions: {
      type: Object,
    },
    series: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>